import { render, staticRenderFns } from "./beforeService.vue?vue&type=template&id=108e0451&scoped=true"
import script from "./beforeService.vue?vue&type=script&lang=js"
export * from "./beforeService.vue?vue&type=script&lang=js"
import style0 from "./beforeService.vue?vue&type=style&index=0&id=108e0451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e0451",
  null
  
)

export default component.exports